import { render, staticRenderFns } from "./shopForm.vue?vue&type=template&id=d4b4b4e6&"
import script from "./shopForm.vue?vue&type=script&lang=js&"
export * from "./shopForm.vue?vue&type=script&lang=js&"
import style0 from "./shopForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "shopForm.vue"
export default component.exports